var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoFeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.24 20.2483C29.3658 19.1225 29.9983 17.5955 29.9983 16.0033C29.9983 14.4112 29.3658 12.8842 28.24 11.7583C27.1142 10.6325 25.5872 10 23.995 10C22.4028 10 20.8758 10.6325 19.75 11.7583L13 18.5083V27.0083H21.5L28.24 20.2483Z",
    stroke: "#6c5ce7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.0084L10 30.0084",
    stroke: "#6c5ce7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.0084H17",
    stroke: "#6c5ce7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoFeather);
export default __webpack_public_path__ + "static/media/icon-logo-feather.55a13b66ffa4c0b5d43779a76cc74ac5.svg";
export { ForwardRef as ReactComponent };